import React, { useEffect, useState } from 'react';
import { reimbursementModStyles } from './ReimbursementMod.styles';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { useSelector } from 'react-redux';
import { selectExpandedModsDialog } from 'store/redux-store/placement-mods/selectors';
import { CategoryDescriptionOptions } from './ReimbursementHelper';
import { reimbursementDescriptionId } from 'app/models/Placement/PlacementMods';

export const StopDate = ({ isModEdit }: { isModEdit: boolean }) => {
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { classes } = reimbursementModStyles({ isExpanded });
  const { control, formState: { errors }, setError, clearErrors } = useFormContext();
  const [isDisabled, setDisabled] = useState(false);
  const endDateValue: any = useWatch({ name: 'initialEndDate' });
  let initialState = true;
  const reimbursementCategoryDescriptionId = useWatch<any>({ name: reimbursementDescriptionId });
  const isEditable = () => {
     if (isModEdit) {
      return ![
        CategoryDescriptionOptions.MiscellaneousCarAllowance,
        CategoryDescriptionOptions.MiscellaneousCellPhoneStipend,
        CategoryDescriptionOptions.MiscellaneousMealAllowance,
        CategoryDescriptionOptions.PerDiemCar,
        CategoryDescriptionOptions.PerDiemCellPhoneStipend,
        CategoryDescriptionOptions.PerDiemHousingAmenities,
        CategoryDescriptionOptions.PerDiemMeal,
      ].includes(reimbursementCategoryDescriptionId);
    }
    return false;
  };
  const isRequired = () => {
    if (isModEdit) {
     return ![
       CategoryDescriptionOptions.MiscellaneousCarAllowance,
       CategoryDescriptionOptions.MiscellaneousCellPhoneStipend,
       CategoryDescriptionOptions.MiscellaneousMealAllowance,
       CategoryDescriptionOptions.MiscellaneousShiftCompletionBonus,
       CategoryDescriptionOptions.PerDiemCar,
       CategoryDescriptionOptions.PerDiemHousingAmenities,
       CategoryDescriptionOptions.PerDiemMeal,
       CategoryDescriptionOptions.PerDiemCellPhoneStipend
     ].includes(reimbursementCategoryDescriptionId);
   }
   return false;
 };

 useEffect(() => {
   if (isEditable() && isNullOrUndefined(endDateValue) && initialState && isRequired()) {
     setError('initialEndDate', {});
   }
   setDisabled(isEditable());
   // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [endDateValue]);

 useEffect(() => {
   if (isEditable() && isNullOrUndefined(endDateValue) && initialState && isRequired()) {
     setError('initialEndDate', {});
   } else {
     clearErrors('initialEndDate');
   }
   setDisabled(isEditable());
   // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [reimbursementCategoryDescriptionId]);

  return (
    <Controller
      control={control}
      name={'initialEndDate'}
      rules={{
        required: isRequired(),
      }}
      render={({ field: { onChange, ...rest } }) => {
        const endDate = moment(endDateValue ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                } else {
                  onChange(null);
                }
                initialState = false;
                clearErrors('initialEndDate');
              }}
              value={endDateValue}
              onCancel={() => { }}
              clear
              open={false}
              variant="filled"
              single
              quickSelect={false}
              placeholder="Stop Date *"
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              labelClass={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={!isDisabled}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: endDate.isValid() ? new Date(endDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: endDate.isValid() ? new Date(endDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
              error={!isNullOrUndefined(errors?.endDate)}
              helperText={!isNullOrUndefined(errors?.endDate) ? 'Required' : undefined}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
